import type React from "react";

function SampleTemplate(): React.ReactNode {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: initial biome migration
    <svg
      version="1.1"
      x="0px"
      y="0px"
      style={{ height: 83, opacity: 0.7, position: "absolute", bottom: -44, width: 83 }}
      width="200px"
      height="200px"
      viewBox="0 0 200 200"
      enableBackground="new 0 0 200 200"
    >
      <g>
        <path
          fill="#FFFFFF"
          d="M183,44v111.702c0,4.751-4.053,8.298-8.804,8.298H93.932c-4.751,0-7.932-3.547-7.932-8.298V24.938
		C86,20.188,89.181,15,93.932,15H150"
        />
        <path
          fill="#FFFFFF"
          d="M115,173.396c0,4.752-3.853,8.604-8.604,8.604H25.604c-4.752,0-8.604-3.852-8.604-8.604V45.604
		C17,40.852,20.853,37,25.604,37h80.791c4.752,0,8.604,3.852,8.604,8.604V173.396z"
        />
        <path
          fill="#8B80AA"
          d="M30.481,78.36h46.571v-2.7H30.481c-0.746,0-1.349,0.604-1.349,1.349S29.735,78.36,30.481,78.36z
		 M30.481,91.858h46.571v-2.7H30.481c-0.746,0-1.349,0.605-1.349,1.351C29.132,91.255,29.735,91.858,30.481,91.858z M30.481,105.358
		h46.571v-2.702H30.481c-0.746,0-1.349,0.605-1.349,1.351C29.132,104.754,29.735,105.358,30.481,105.358z M30.481,145.854h46.571
		v-2.699H30.481c-0.746,0-1.349,0.605-1.349,1.351S29.735,145.854,30.481,145.854z M30.481,156.652
		c-0.746,0-1.349,0.605-1.349,1.351s0.604,1.35,1.349,1.35H77.31c-0.168-0.89-0.255-1.794-0.258-2.7H30.481L30.481,156.652z
		 M85.752,170.152H30.481c-0.746,0-1.349,0.604-1.349,1.349c0,0.747,0.604,1.351,1.349,1.351h70.194c0.745,0,1.35-0.604,1.35-1.351
		l0,0H91.901C89.777,171.5,87.68,171.04,85.752,170.152z M91.901,166.103h85.043c5.219,0,9.448-4.231,9.448-9.449v-0.001V44.155
		l-37.415-30.59H91.901c-5.218,0-9.45,4.23-9.45,9.449v0.001v133.638c0,5.218,4.23,9.449,9.448,9.449
		C91.901,166.103,91.901,166.103,91.901,166.103z M152.646,24.821l20.889,17.091h-17.1c-2.058,0.031-3.753-1.608-3.789-3.667V24.821
		L152.646,24.821z M87.851,23.015c0.003-2.238,1.814-4.048,4.051-4.051h53.586l1.759,1.439v17.842
		c0.034,5.041,4.148,9.1,9.189,9.068h23.7l0.857,0.702v108.638c-0.003,2.236-1.813,4.048-4.049,4.051H91.901
		c-2.236-0.003-4.048-1.814-4.051-4.051V23.015z"
        />
        <path
          fill="#8B80AA"
          d="M99.325,58.111h70.194c0.745,0,1.351-0.604,1.351-1.35c0-0.745-0.605-1.351-1.351-1.351H99.325
		c-0.745,0-1.351,0.605-1.351,1.351C97.975,57.507,98.58,58.111,99.325,58.111z M99.325,71.609h70.194
		c0.745,0,1.351-0.604,1.351-1.349c0-0.746-0.605-1.351-1.351-1.351H99.325c-0.745,0-1.351,0.605-1.351,1.351
		C97.975,71.005,98.58,71.609,99.325,71.609z M99.325,85.109h70.194c0.745,0,1.351-0.604,1.351-1.349
		c0-0.747-0.605-1.351-1.351-1.351H99.325c-0.745,0-1.351,0.604-1.351,1.351C97.975,84.505,98.58,85.109,99.325,85.109z
		 M99.325,125.604h70.194c0.745,0,1.351-0.604,1.351-1.349s-0.605-1.351-1.351-1.351H99.325c-0.745,0-1.351,0.605-1.351,1.351
		S98.58,125.604,99.325,125.604z M99.325,139.104h70.194c0.745,0,1.351-0.604,1.351-1.349c0-0.747-0.605-1.351-1.351-1.351H99.325
		c-0.745,0-1.351,0.604-1.351,1.351C97.975,138.501,98.58,139.104,99.325,139.104z M99.325,152.604h70.194
		c0.745,0,1.351-0.604,1.351-1.35s-0.605-1.351-1.351-1.351H99.325c-0.745,0-1.351,0.605-1.351,1.351S98.58,152.604,99.325,152.604z
		"
        />
        <path
          fill="#8B80AA"
          d="M23.057,180.95c-2.235-0.001-4.048-1.813-4.049-4.049V43.262c0.001-2.236,1.814-4.048,4.049-4.05h60.633
		l0.409,0.334v-5.733H23.057c-5.219,0-9.449,4.23-9.449,9.449l0,0v133.639c0.001,1.4,0.316,2.785,0.92,4.049"
        />
        <path
          fill="#8B80AA"
          d="M116.628,180.95c0.605-1.264,0.919-2.648,0.922-4.049v-13.62h-5.401v13.62
		c-0.001,2.235-1.813,4.048-4.049,4.049"
        />
        <path
          fill="#BDB7CF"
          d="M30.481,118.856h46.571v-2.7H30.481c-0.746,0-1.349,0.604-1.349,1.351
		C29.132,118.252,29.735,118.856,30.481,118.856z M77.052,129.654H30.481c-0.746,0-1.349,0.605-1.349,1.351s0.604,1.351,1.349,1.351
		h46.571V129.654z M169.52,95.907H99.325c-0.745,0-1.351,0.605-1.351,1.351s0.605,1.35,1.351,1.35h70.194
		c0.745,0,1.351-0.604,1.351-1.35S170.265,95.907,169.52,95.907z M169.52,109.407H99.325c-0.745,0-1.351,0.605-1.351,1.351
		s0.605,1.349,1.351,1.349h70.194c0.745,0,1.351-0.604,1.351-1.349S170.265,109.407,169.52,109.407z"
        />
        <path
          fill="#8B80AA"
          d="M112.178,176.985c-0.003,2.236-1.813,4.048-4.049,4.051H23.086c-2.236-0.003-4.048-1.814-4.051-4.051
		l-5.4,0.001c0,5.218,4.231,9.449,9.449,9.449c0.001,0,0.001,0,0.001,0h85.043c5.219,0,9.449-4.231,9.449-9.449v-0.001H112.178z"
        />
      </g>
    </svg>
  );
}

export default SampleTemplate;
